function Historique(){
    let blockHistorique = document.querySelector('.block.historique');
    if(blockHistorique){
        let items = document.querySelectorAll('.block.historique .historique__history__item');
        items.forEach(element => {

            if(element.closest(".history-futur")){
                return false;
            }
            element.addEventListener('mouseenter', (e) => {
                e.target.classList.add('onhover');
                let h = e.target.getAttribute('data-hover');
                let itemsExceptThis= document.querySelectorAll('.historique__history__item:not(.onhover)');
                let image = document.querySelectorAll('.block.historique .historique__images .image');
                itemsExceptThis.forEach(el => {
                    el.style.opacity = "0.4";
                });
                image.forEach(el => {
                    el.style.opacity = "0.4";
                });
                document.querySelector('.block.historique .historique__images .image[data-hover="'+h+'"]').style.opacity = "1";
            });
            element.addEventListener('mouseleave', (e) => {
                e.target.classList.remove('onhover');
                let h = e.target.getAttribute('data-hover');
                let image = document.querySelectorAll('.block.historique .historique__images .image');
                items.forEach(el => {
                    el.style.opacity = "1";
                });
                image.forEach(el => {
                    el.style.opacity = "1";
                });
            });
        });

    }
}
Historique();
